<template>
  <div class="empty" :style="position">
    <i class="las la-cloud-meatball"></i>
    <p class="text-center">{{ content }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    content: {
      type: String,
      default: "暂无数据",
    },
    position: {
      type: Object,
      default: () => {},
    },
  },
  methods: {},
  components: {},
};
</script>

<style scoped lang="scss">
.empty {
  font-size: 1rem;
  font-weight: 500;
  color: rgba(20, 17, 15, 0.64);
  position: absolute;
  top: 200px;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  i {
    font-size: 5rem;
  }
}
</style>
